import useReduxState from "@hooks/useReduxState";
import styles from "./chat-list.module.scss";
import ChatMessage from "./chat-message";
import cn from "classnames";
import { useEffect, useRef } from "react";

export default function ChatList(): JSX.Element {
  const [{ messages, collapsed }] = useReduxState((state) => state.chat);
  const listElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (listElement && listElement.current) {
      listElement.current.scrollTo({
        top:
          listElement.current.scrollHeight - listElement.current.clientHeight,
        behavior: "smooth",
      });
    }
  }, [messages.length]);

  return (
    <div className={styles.chat_list}>
      <div className={styles.chat_gradient} />
      <div
        ref={listElement}
        className={cn(styles.list, {
          [styles.list_collapsed]: collapsed,
        })}
      >
        {[...messages].map((message) => (
          <ChatMessage
            key={`${message.user.username}-${Math.random()}`}
            {...{ message }}
          />
        ))}
      </div>
    </div>
  );
}
